import { ToggleGroup, ToggleGroupItem, createClasses } from '@kp/react-ui';

import {
  AVAILABLE_TIMESPANS,
  type DashboardPeriod,
  TIMESPAN_LABEL,
} from '@/constants/dashboard-period';

const classes = createClasses({
  option: {
    padding: '2px 13px',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    height: '24px',
  },
});

interface TimePeriodFilterProps {
  options?: readonly DashboardPeriod[];
  value: DashboardPeriod;
  onChange: (value: DashboardPeriod) => void;
  className?: string;
}

export const TimePeriodFilter: React.FC<TimePeriodFilterProps> = ({
  options = AVAILABLE_TIMESPANS,
  value,
  onChange,
  className,
}) => {
  return (
    <div className={className}>
      <ToggleGroup
        value={value}
        onChange={(val) => onChange(val as DashboardPeriod)}
      >
        {options.map((option) => (
          <ToggleGroupItem
            key={option}
            value={option}
            className={classes.option}
          >
            {TIMESPAN_LABEL[option]}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  );
};
